<mat-expansion-panel
  hideToggle
  #panel="matExpansionPanel"
  [expanded]="panelOpenState"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
>
  <mat-expansion-panel-header expandedHeight="47px" collapsedHeight="47px">
    <mat-panel-title>
      <span><strong>{{title}}&nbsp;</strong> {{subtitle}} </span>
    </mat-panel-title>
    <mat-icon *ngIf="!panelOpenState">add</mat-icon>
    <mat-icon *ngIf="panelOpenState">remove</mat-icon>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
